import { render, staticRenderFns } from "./ComponentConteudoInicial.vue?vue&type=template&id=9ae50d6a&scoped=true&"
import script from "./ComponentConteudoInicial.vue?vue&type=script&lang=js&"
export * from "./ComponentConteudoInicial.vue?vue&type=script&lang=js&"
import style0 from "./ComponentConteudoInicial.vue?vue&type=style&index=0&id=9ae50d6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae50d6a",
  null
  
)

export default component.exports